import {
  CreateSpecialtyGroupException,
  SpecialtyGroupException,
  SpecialtyGroupExceptionDisplay,
  SpecialtyGroupExceptionHistory,
  UpdateSpecialtyGroupException,
} from "@app/projects/results/common";
import { ServiceBase } from "@app/shared";

/** Handles communication across the wire when retrieving and interacting with specialty group exceptions. */
export default class SpecialtyGroupExceptionsService extends ServiceBase {

  public async getSpecialtyGroupException(projectId: number, specialtyGroupExceptionId: number): Promise<SpecialtyGroupException> {
    return await this.makeGet<SpecialtyGroupException>(`specialtygroupexceptions/${projectId}/specialtygroupexceptions/${specialtyGroupExceptionId}`);
  }

  public async getSpecialtyGroupExceptions(projectId: number): Promise<SpecialtyGroupException[]> {
    return await this.makeGet<SpecialtyGroupException[]>(`specialtygroupexceptions/${projectId}/specialtygroupexceptions`);
  }

  public async getSpecialtyGroupExceptionsByRunConfigurationId(projectId: number, runConfigurationId: number): Promise<SpecialtyGroupException[]> {
    return await this.makeGet<SpecialtyGroupException[]>(`specialtygroupexceptions/${projectId}/runconfigurations/${runConfigurationId}/specialtygroupexceptions`);
  }

  public async getSpecialtyGroupExceptionDisplays(projectId: number): Promise<SpecialtyGroupExceptionDisplay[]> {
    return await this.makeGet<SpecialtyGroupExceptionDisplay[]>(`specialtygroupexceptions/${projectId}/specialtygroupexceptiondisplays`);
  }

  public async getUnprocessedSpecialtyGroupExceptions(projectId: number): Promise<SpecialtyGroupExceptionDisplay[]> {
    return await this.makeGet<SpecialtyGroupExceptionDisplay[]>(`specialtygroupexceptions/${projectId}/unprocesssed-specialty-group-exceptions`);
  }

  public async processUnprocessedSpecialtyGroupExceptions(projectId: number): Promise<SpecialtyGroupExceptionDisplay[]> {
    return await this.makePost<SpecialtyGroupExceptionDisplay[]>(`specialtygroupexceptions/${projectId}/specialtygroupexceptions/Process-Unprocessed`);
  }

  public async createSpecialtyGroupException(projectId: number, createSpecialtyGroupException: CreateSpecialtyGroupException): Promise<SpecialtyGroupException> {
    return await this.makePost<SpecialtyGroupException>(`specialtygroupexceptions/${projectId}/specialtygroupexceptions`, createSpecialtyGroupException);
  }

  public async updateSpecialtyGroupException(projectId: number, updateSpecialtyGroupException: UpdateSpecialtyGroupException): Promise<SpecialtyGroupException> {
    return await this.makePatch<SpecialtyGroupException>(`specialtygroupexceptions/${projectId}/specialtygroupexceptions`, updateSpecialtyGroupException);
  }

  public async getSpecialtyGroupExceptionHistory(customProjectId: number, regionSetId: number, specialtyGroupCode: string): Promise<SpecialtyGroupExceptionHistory[]> {
    if (!customProjectId || !regionSetId || !specialtyGroupCode) {
      return null;
    }
    return await this.makeGet<SpecialtyGroupExceptionHistory[]>(`specialtygroupexceptions/${customProjectId}/regionSets/${regionSetId}/specialtygroupexceptionhistory`, { specialtyGroupCode });
  }

  //TODO: DELETE OLD METHOD AND RENAME THIS ONE BECAUSE TYPESCRIPT DOESN'T UNDERSTAND OVERLOADING
  public async getSpecialtyGroupExceptionHistoryById(customProjectId: number, regionSetSpecialtyGroupId: number): Promise<SpecialtyGroupExceptionHistory[]> {
    if (!customProjectId || !regionSetSpecialtyGroupId) {
      return null;
    }
    return await this.makeGet<SpecialtyGroupExceptionHistory[]>(`specialtygroupexceptions/${customProjectId}/regionSetSpecialtyGroups/${regionSetSpecialtyGroupId}/specialtygroupexceptionhistory`);
  }

  public async hasUnprocessedSpecialtyGroupExceptions(): Promise<boolean> {
    return await this.makeGet<boolean>(`specialtygroupexceptions/has-unprocessed`);
  }

  public async bulkProcessUnprocessedSpecialtyGroupExceptions(): Promise<string> {
    return await this.makePost<string>(`specialtygroupexceptions/process-unprocessed/bulk`);
  }
}